(function ($) {

    $(document).ready(function () {
        let currentPageUrl = location.pathname;
        const getRecaptchaToken = () => {
            if (typeof grecaptcha === 'undefined') return;
            const businessRecaptchaSiteKey = '6LdcE5EdAAAAAFnQiqownkSD9ZsOYb0LFHzSlAWH';
            grecaptcha.ready(function () {
                grecaptcha.execute(businessRecaptchaSiteKey, { action: "" })
                    .then(function (token) {
                        document.getElementById("g-recaptcha-response-business").value = token;
                    });
            });
        }
        if (currentPageUrl.indexOf('online-lounge-request') > -1 || currentPageUrl.indexOf('onlayn-zayavka-za-salon') > -1) {
            getRecaptchaToken();
            // Every 90 Seconds reset token
            setInterval(function () {
                getRecaptchaToken();
            }, 90 * 1000);
        }

        if ($('#lounge_form').length > 0) {

            const { __, _x, _n, _nx } = wp.i18n;

            const loungeForm = $('form#lounge_form');

            if (loungeForm.length > 0) {

                //flight date - choose a date
                const flightDate = loungeForm.find("#flight_date");
                flightDate.datepicker({
                    changeMonth: true,
                    changeYear: true,
                    dateFormat: "dd/mm/yy",
                    minDate: 0,
                    maxDate: "+1Y",
                    firstDay: 1
                });

                //regex the flight number
                $.validator.addMethod(
                    "regexFlightNo",
                    function (value, element) {
                        return this.optional(element) || /^([a-zA-Z0-9]+)$/i.test(value);
                    },
                    __('Wrong flight number', 'sofia-airport')
                );

                //regex the flight date
                $.validator.addMethod(
                    "regexDateFormat",
                    function (value, element, regexp) {
                        const re = new RegExp(regexp);
                        return this.optional(element) || re.test(value);
                    },
                    __('Wrong date format', 'sofia-airport')
                );

                //regex the flight date
                $.validator.addMethod(
                    "regexTimeFormat",
                    function (value, element) {
                        return this.optional(element) || /^([0-9]{2}:[0-9]{2})$/i.test(value);
                    },
                    __('Wrong time format', 'sofia-airport')
                );

                loungeForm.validate({
                    rules: {
                        sender_name: {
                            required: true,
                        },
                        flight_no: {
                            required: true,
                            minlength: 5,
                            maxlength: 7,
                            regexFlightNo: true
                        },
                        flight_date: {
                            required: true,
                            regexDateFormat: /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/
                        },
                        flight_time: {
                            required: false,
                            regexTimeFormat: true
                        },
                        adults: {
                            required: false,
                            digits: true
                        },
                        kids_under_six: {
                            required: false,
                            digits: true
                        },
                        kids_under_three: {
                            required: false,
                            digits: true
                        },
                        sender_email: {
                            required: true,
                            email: true
                        },
                        remarks: {
                            required: false
                        },
                    },
                    submitHandler: function (form) {

                        let loungeRequestData = {
                            'website': $('input[name=website]').val(),
                            'senderName': $('input[name=sender_name]').val(),
                            'flightNo': $('input[name=flight_no]').val(),
                            'flightDate': $('input[name=flight_date]').val(),
                            'loungeEmail': $('#lounge').attr('data-email'),
                            'lounge': 'VIP Lounge',
                            'flightTime': $('input[name=flight_time]').val(),
                            'adults': $('input[name=adults]').val(),
                            'kidsUnderSix': $('input[name=kids_under_six]').val(),
                            'kidsUnderThree': $('input[name=kids_under_three]').val(),
                            'senderEmail': $('input[name=sender_email]').val(),
                            'remarks': $('textarea[name=remarks]').val(),
                        };

                        let businessRecaptchaResponse = $('#g-recaptcha-response-business').val();
                        //send search request
                        loungeRequestData = JSON.parse(JSON.stringify(loungeRequestData));

                        $.ajax({
                            type: "POST",
                            url: "/wp-admin/admin-ajax.php",
                            dataType: "JSON",
                            data: {
                                action: "lounge_form",
                                data: loungeRequestData,
                                businessRecaptchaResponseData: businessRecaptchaResponse,
                            },
                            success: function (resp) {
                                // This outputs the result of the ajax request
                                if (resp.success == false) {
                                    $('#responseBox').text(resp.data);
                                } else {
                                    $('#responseBox').text(resp.data);
                                    form.reset();
                                }
                                getRecaptchaToken();
                            },
                            error: function (errorThrown) {
                                //Returns the thrown error
                                getRecaptchaToken();
                            }
                        });

                    }
                });

                $.extend($.validator.messages, {
                    minlength: __('Wrong flight number', 'sofia-airport'),
                    maxlength: __('Wrong flight number', 'sofia-airport'),
                    required: __('The field is required', 'sofia-airport'),
                    digits: __('Please enter only digits', 'sofia-airport'),
                });
            }
        }

    });
})(jQuery);